import React from 'react';
import EmptyState from '../../common/EmptyState';

/**
 * What a section shows while it is not ready: loading, empty, no access, or
 * an error with a Retry that runs the request again. `what` names the
 * section's content in lower case ("writing", "exam practice").
 * Returns null when the section is ready, so callers render their content.
 */
const SectionState = ({ state, what, emptyTitle, emptyBody }) => {
  switch (state.status) {
    case 'loading':
      return <p className="td-loading" role="status">{`Loading ${what}…`}</p>;
    case 'empty':
      return <EmptyState title={emptyTitle} body={emptyBody} />;
    case 'forbidden':
      return <EmptyState tone="warning" title="You do not have access to this student." />;
    case 'error':
      return (
        <EmptyState
          tone="warning"
          title={`Could not load ${what}`}
          body={state.error}
          action={(
            <button type="button" className="td-btn td-btn--small td-act-retry" onClick={state.retry}>
              Retry
            </button>
          )}
        />
      );
    default:
      return null;
  }
};

export default SectionState;
